import React, { forwardRef, useState, useEffect } from "react";
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import RealizedtHeader from './realized-report-pdf-header';
import RealizedContent from './realized-report-pdf-content';
import RealizedTable from './realized-report-pdf-table'; // Uncomment if needed
import callingAPI from "../service"
import { useSelector } from "react-redux";
const InvestmentAccountActivityReportPdf = forwardRef((props, ref) => {
    const reportDetails = useSelector((state) => state.report.realized);
    const [realizedSummery, setRealizedSummery] = useState([])
    const [clientAddressDetails, setClientAddressDetails] = useState({
        building: "48 Burj Gate",
        street: "Sheikh Zayed Road",
        citya: "Dubai",
        countrya: "United Arab Emirates",
        officeno: "801",
        trnno: "",
        mobile: "919961727479",
        postbox: "119930"
    });
    const [realizedDetails, setRealizedDetails] = useState([])
    const [realizedSummeryTotal, setRealizedSummeryTotal] = useState([])
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const refreshToken = dashboardDetails.refreshToken;


    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '21cm', // A4 paper height in cm
        width: '100%',
        margin: '0 auto',
        padding: '0 15px 0 15px', // 15px left and right padding, 2cm padding bottom for the footer
        position: 'relative',
        fontFamily: 'Roboto Medium',
        color: '#000',
        fontSize: '13px',
        boxSizing: 'border-box' // Ensures padding doesn't affect the width
    };

    const htmlBodyStyle = {
        width: '100%',
        margin: '0',
        padding: '0',
        overflowX: 'hidden' // Hides horizontal scroll globally
    };

    const headerStyle = {
        // marginBottom: '1cm',
    };

    const mainStyle = {
        flex: '1',
        marginBottom: '1cm',
    };

    const footerStyle = {
        width: '100%',
        boxSizing: 'border-box',
        borderTop: '2px solid #d5d5d5',
        textAlign: 'center',
        fontSize: '12px',
        padding: '5px',
        position: 'absolute',
        bottom: '-10px',
    };
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0]; // Converts to YYYY-MM-DD format
    };
    useEffect(() => {
        setRealizedSummery(reportDetails?.realizedSummery || []);
        setClientAddressDetails(reportDetails?.clientAddressDetails || clientAddressDetails); // Use dynamic data or fallback to sample

        setRealizedSummeryTotal(reportDetails?.total || []);
        setRealizedDetails(reportDetails?.realizedDetails || []);

    }, [reportDetails]);
    useEffect(() => {
        document.documentElement.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
        document.body.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
    }, []);


    const cashSummaryReportList = () => {
        const clientId = dashboardDetails.clientid;
        const userId = dashboardDetails.userId
        const postData = {
            "userId": userId,
            "fromDate": props.fromDate != undefined ? formatDate(props.fromDate) : formatDate(new Date()),
            "toDate": props.toDate != undefined ? formatDate(props.toDate) : formatDate(new Date()),
            "clientId": clientId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/realized", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    setRealizedSummery(data.data.realizedSummery || []);
                    setClientAddressDetails(data.data?.clientAddressDetails || clientAddressDetails); // Use dynamic data or fallback to sample

                    setRealizedSummeryTotal(data.data.total || []);
                    setRealizedDetails(data.data.realizedDetails || []);
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };
    const formattedDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const fromDate = formattedDate(props.fromDate); // format 'fromDate'
    const toDate = formattedDate(props.toDate); // format 'toDate'

    // const totalAEDBalance = (cashStatementSummeryTotal || []).reduce((total, item) => total + parseFloat(item?.total), 0);
    const totalAEDBalance = parseFloat(realizedSummeryTotal);

    return (
        <div ref={ref} id="pdf-content">
            <div style={containerStyle} ref={ref} id="pdf-content">
                <header style={headerStyle}>
                    <RealizedtHeader headerName="Realized Gain / Loss Summary" clientAddressDetails={clientAddressDetails} fromDate={fromDate} toDate={toDate} />
                </header>
                <hr />
                <main style={mainStyle}>
                    <RealizedContent realizedSummery={realizedSummery} totalAEDBalance={totalAEDBalance} />

                </main>
                <footer style={footerStyle}>
                    <div style={{ lineHeight: "15px" }}>
                        <div>A Subsidiary of DUBAI INVESTMENTS</div>
                        <div>
                            {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                            Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                        </div>
                        <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno}</div>
                    </div>
                    <div className="pb-2 pt-3" style={{ lineHeight: "15px" }}>
                        <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                        <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                    </div>
                </footer>
            </div>
            <div style={containerStyle} >
                <div style={mainStyle}>
                    <RealizedTable realizedDetails={realizedDetails} clientAddressDetails={clientAddressDetails} fromDate={fromDate} toDate={toDate} />
                </div>

            </div>
        </div>

    );
});

export default InvestmentAccountActivityReportPdf;

